import { Injectable } from '@angular/core';

import type { RedactorConfig } from '@recruitee/wysiwyg';

@Injectable({ providedIn: 'root' })
export class IntegrationsRedactorService {
  public get emailTemplateConfig(): RedactorConfig {
    return {
      buttons: ['bold', 'italic', 'underline', 'lists', 'alignment', 'link', 'undo', 'redo'],
      activeButtons: {
        b: 'bold',
        strong: 'bold',
        i: 'italic',
        u: 'underline',
        em: 'italic',
        del: 'deleted',
        strike: 'deleted',
      },
      plugins: ['rt-quote', 'resize', 'alignment', 'bufferbuttons'],
      rtPlaceholdersExcludeParentSelector: '.recruitee-quote',
      quoteClass: 'recruitee-quote',
      maxHeight: '800px',
      minHeight: '200px',
      pasteBlockTags: [
        'br',
        'p',
        'ul',
        'li',
        'ol',
        'b',
        'i',
        'u',
        'strong',
        'a',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
      ],
      toolbarFixed: false,
      linkSize: 2083,
    };
  }
}
